import { render, staticRenderFns } from "./SavedOrder.vue?vue&type=template&id=d9de4860&scoped=true"
import script from "./SavedOrder.vue?vue&type=script&lang=js"
export * from "./SavedOrder.vue?vue&type=script&lang=js"
import style0 from "./SavedOrder.vue?vue&type=style&index=0&id=d9de4860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9de4860",
  null
  
)

export default component.exports